import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _slicedToArray from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import { areaList } from "@vant/area-data";
import help from "../assets/js/help";
import { mapMutations, mapState } from "vuex";
import bus from "vue3-eventbus";
export default {
  name: "AddressEditor",
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    saveText: {
      type: String,
      default: "保存"
    },
    cancelText: {
      type: String,
      default: "取消"
    }
  },
  data: function data() {
    return {
      areaList: areaList,
      searchResult: [],
      addressInfo: {},
      showArea: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "isTest"])), {}, {
    notEmpty: function notEmpty() {
      return Object.keys(this.item).length;
    },
    url: function url() {
      if (this.isTest) {
        return "/club/json/update-address.json";
      } else {
        return "/api/goods/edit-address";
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setTotalIngral", "setAppInfo"])), {}, {
    updateJoinInfo: function updateJoinInfo(params) {
      var _this = this;

      this.axios.post("/api/activity/invitation-update", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (res) {
        if (res) {
          help.requestSuccess(res).then(function (res) {
            console.log(res);

            _this.onClickClose();
          }, function (err) {
            console.log(err);
            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onSave: function onSave(content) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2$$refs$addressL, _this2$$refs$addressL2, _provinceCode, _cityCode, _areaCode, addressDetail, areaCode, name, tel, applicationId, _content;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2$$refs$addressL = _this2.$refs.addressList.getArea(), _this2$$refs$addressL2 = _slicedToArray(_this2$$refs$addressL, 3), _provinceCode = _this2$$refs$addressL2[0], _cityCode = _this2$$refs$addressL2[1], _areaCode = _this2$$refs$addressL2[2];
                addressDetail = content.addressDetail, areaCode = content.areaCode, name = content.name, tel = content.tel;
                applicationId = _this2.item.applicationId;
                _content = {
                  "addr": addressDetail,
                  "platformSource": _this2.source,
                  "id": applicationId - 0,
                  "mobile": tel,
                  "name": name,
                  "time": _this2.time,
                  "token": _this2.token,
                  "uid": _this2.uid - 0
                };
                console.log(_content);

                _this2.updateJoinInfo(_content);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onDelete: function onDelete() {
      console.log(1);

      _Toast("delete");
    },
    validator: function validator(e) {
      var reg = /^1[1-9]\d{9}$/;
      return reg.test(e);
    },
    onClickAddress: function onClickAddress() {
      var _id = this.$route.params.id;
      var _type = "material";
      this.$router.push({
        path: "/address/" + _id + "/"
      });
    },
    resetAddress: function resetAddress() {},
    onClickClose: function onClickClose() {
      console.log("buson");
      bus.emit("overlayClose", false);
    }
  }),
  mounted: function mounted() {
    var _address = this.item;

    if (this.notEmpty) {
      this.addressInfo = {
        addressDetail: _address.addr,
        name: _address.name,
        tel: _address.mobile,
        id: _address.applicationId
      };
    }
  }
};